import React, { useMemo } from 'react'
import { Dot, LoaderComponent, LoaderContainer, LoaderWrapper } from './mixins'
import { IS_ZONA_JOBS } from '../../constants/index'

export const LoaderToLazy = () => {
  // los normal de cada uno
  const colors = useMemo(
    () => ({
      tertiary: IS_ZONA_JOBS ? '#2E9DCD' : '#00DCD4',
      secondary: IS_ZONA_JOBS ? '#585992' : '#0A26EE',
      primary: IS_ZONA_JOBS ? '#FF652B' : '#E90066',
    }),
    []
  )
  return (
    <LoaderWrapper>
      <LoaderContainer>
        <LoaderComponent>
          <Dot {...colors} />
          <Dot {...colors} />
          <Dot {...colors} />
          <Dot {...colors} />
          <Dot {...colors} />
        </LoaderComponent>
      </LoaderContainer>
    </LoaderWrapper>
  )
}

export default LoaderToLazy
